// src/utils/secureStorage.js
import CryptoJS from 'crypto-js';

// 🔐 کلید رمزنگاری (این کلید در APK مخفی می‌ماند)
const SECRET_KEY = 'yadoo20-super-secure-key-2026';

export const setSecureItem = (key, value) => {
  try {
    const encrypted = CryptoJS.AES.encrypt(String(value), SECRET_KEY).toString();
    localStorage.setItem(key, encrypted);
  } catch (e) {
    console.warn('خطا در رمزنگاری:', e);
  }
};

export const getSecureItem = (key) => {
  try {
    const encrypted = localStorage.getItem(key);
    if (!encrypted) return null;
    const bytes = CryptoJS.AES.decrypt(encrypted, SECRET_KEY);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    // اگر رمزگشایی ناموفق بود (کاربر دستکاری کرده)، برگردان null
    return decrypted || null;
  } catch (e) {
    localStorage.removeItem(key); // پاک کردن داده خراب
    return null;
  }
};

export const removeSecureItem = (key) => {
  localStorage.removeItem(key);
};

// توابع میانبر برای توکن و شناسه کاربر
export const setToken = (token) => setSecureItem('auth_token', token);
export const getToken = () => getSecureItem('auth_token');
export const removeToken = () => removeSecureItem('auth_token');

export const setUserId = (id) => setSecureItem('auth_userId', id);
export const getUserId = () => getSecureItem('auth_userId');
export const removeUserId = () => removeSecureItem('auth_userId');